import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs/operators';
import { HeaderComponent } from '../components/header/header.component';
import { FooterV2Component } from '../components/footer-v2/footer-v2.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { EditorialBannerComponent } from '../components/editorial-banner/editorial-banner.component';
import { AncFooterComponent } from '../anc/anc-footer.component';
import { AncHeaderComponent } from '../anc/anc-header.component';

@Component({
  selector: 'app-main-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterV2Component,
    TranslocoPipe,
    EditorialBannerComponent,
    AncHeaderComponent,
    AncFooterComponent,
  ],
  styles: [
    `
      /* Annule la réserve .head-spacer du header (hauteurs par palier). */
      .under-header {
        margin-top: -112px;
      }
      @media (max-width: 1279px) {
        .under-header {
          margin-top: -104px;
        }
      }
      @media (max-width: 1023px) {
        .under-header {
          margin-top: -96px;
        }
      }
      @media (max-width: 480px) {
        .under-header {
          margin-top: -66px;
        }
      }
    `,
  ],
  template: `
    <div class="min-h-screen flex flex-col bg-[var(--bg-primary)] text-[var(--text-primary)] relative">
      <a href="#main-content" class="skip-link">{{ 'common.skipToContent' | transloco }}</a>

      @if (!isHome2()) {
        <!-- Direction artistique d'octobre 2026 : navigation et pied de page de tout le site. -->
        <app-anc-header />
        <main id="main-content" class="flex-grow">
          <router-outlet />
        </main>
        <app-anc-footer />
      } @else {
        <app-header />
        <app-editorial-banner />

        <main id="main-content" class="flex-grow relative z-10 under-header">
          <router-outlet />
        </main>

        <app-footer-v2 />
      }
    </div>
  `,
})
export class MainLayoutComponent {
  private readonly router = inject(Router);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects),
      startWith(this.router.url)
    ),
    { initialValue: this.router.url }
  );

  /** L'ancienne maquette d'accueil (/xx/home2, noindex) garde son en-tête et son pied de page d'origine. */
  readonly isHome2 = computed(() => /^\/[a-z]{2}\/home2\/?$/.test((this.currentUrl() ?? '/').split(/[?#]/)[0]));
}
